// extracted by mini-css-extract-plugin
export default {"paginationContainer":"paginationContainer--1Y82M"};